module.exports = __webpack_public_path__ + "static/media/background_inicio_ebmi.cf7529cc.png";